import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=18a50f50&scoped=true"
import script from "./js/dashboard.js?vue&type=script&lang=js&external"
export * from "./js/dashboard.js?vue&type=script&lang=js&external"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=18a50f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a50f50",
  null
  
)

export default component.exports